<template>
  <router-view />
</template>

<script>
export default {
  name: "SampleReceiveNest"
};
</script>
